/**
 * Created by therbst-ext on 05.04.2017.
 */
export class PixelSnapping {
    public static ALWAYS: string = "always";
    public static AUTO: string = "auto";
    public static NEVER: string = "never";
}